import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const getKeys = (search) => {
	const params = {};

	for (const [key, value] of new URLSearchParams(search).entries()) {
		if (!params[key]) {
			params[key] = value;
		} else {
			const oldValues = Array.isArray(params[key])
				? params[key]
				: [params[key]];
			params[key] = [...oldValues, value];
		}
	}

	return params;
};

export default function useSearchParams() {
	const { search } = useLocation();

	return useMemo(() => {
		return getKeys(search);
	}, [search]);
}
